import React from 'react'
import { Card, Table, Pagination } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getUserDetailAPI, getUserHouseViewListAPI } from '@/apis/user'
const { Column } = Table
import styles from './userInfo.module.scss'
import Dayjs from 'dayjs'

export default function HouseList() {
  const location = useParams()
  const userId = location.userid
  const tabList = [30, 90, 180]
  const [tabIndex, setTabIndex] = useState(0)
  const [userInfo, setUserInfo] = useState({}) //  用户信息
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  const [listQuery, setListQuery] = useState({
    userId,
    days: tabList[tabIndex],
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  楼盘总数
  const [list, setList] = useState(0) //  楼盘列表
  const [priceList, setPriceList] = useState([])
  const [districtList, setDistrictList] = useState([])
  const [plateList, setPlateList] = useState([])

  //  用户信息
  const getDetail = async () => {
    const res = await getUserDetailAPI({ userId })
    if (res.success === true) {
      if (res.result) {
        setUserInfo(res.result)
      }
    }
  }

  //  楼盘列表
  const fetchData = async () => {
    setListLoading(true)
    const res = await getUserHouseViewListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
          item.firstVisitTime = Dayjs(item.firstVisitTime).format('YYYY-MM-DD')
          item.newVisitTime = Dayjs(item.newVisitTime).format('YYYY-MM-DD')
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      if (listQuery.pageInt === 1) {
        getUserAllHouseViewList(res.result.total)
      }
      setListLoading(false)
    }
  }
  //  所有楼盘列表
  const getUserAllHouseViewList = async total => {
    let priceList = [
      {
        name: '0.8万以下',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '0.8-1万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '1-1.5万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '1.5-2万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '2-2.5万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '2.5-3万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '3-4万',
        value: 0,
        rate: '' // 占比
      },
      {
        name: '4万以上',
        value: 0,
        rate: '' // 占比
      }
    ]
    let districtList = []
    let districtIds = []
    let plateList = []
    let plateIds = []
    const res = await getUserHouseViewListAPI({ userId, days: tabList[tabIndex], pageInt: 1, pageSize: total })
    if (res.success === true) {
      if (res.result.list) {
        let total_new = 0
        res.result.list.forEach(item => {
          let districtIndex = districtIds.indexOf(item.districtId)
          if (districtIndex < 0) {
            districtIds.push(item.districtId)
            districtList.push({
              id: item.districtId,
              name: item.districtName,
              value: 1,
              rate: ((1 / res.result.total) * 100).toFixed(0) + '%'
            })
          } else {
            districtList[districtIndex].value++
            districtList[districtIndex].rate = ((districtList[districtIndex].value / res.result.total) * 100).toFixed(0) + '%'
          }
          let plateIndex = plateIds.indexOf(item.plateId)
          if (plateIndex < 0) {
            plateIds.push(item.plateId)
            plateList.push({
              id: item.plateId,
              name: item.plateName,
              value: 1,
              rate: ((1 / res.result.total) * 100).toFixed(0) + '%'
            })
          } else {
            plateList[plateIndex].value++
            plateList[plateIndex].rate = ((plateList[plateIndex].value / res.result.total) * 100).toFixed(0) + '%'
          }
          if(item.price > 0) {
            total_new++
            if (item.price >= 40000) {
              priceList[7].value++
            } else if (item.price >= 30000) {
              priceList[6].value++
            } else if (item.price >= 25000) {
              priceList[5].value++
            } else if (item.price >= 20000) {
              priceList[4].value++
            } else if (item.price >= 15000) {
              priceList[3].value++
            } else if (item.price >= 10000) {
              priceList[2].value++
            } else if (item.price >= 8000) {
              priceList[1].value++
            } else {
              priceList[0].value++
            }
          }
        })
        priceList.forEach(item => {
          item.rate = ((item.value / total_new) * 100).toFixed(0) + '%'
        })
        priceList.sort((a, b) => {
          return b.value - a.value
        })
        priceList = priceList.slice(0, 3)
        districtList.sort((a, b) => {
          return b.value - a.value
        })
        districtList = districtList.slice(0, 3)
        plateList.sort((a, b) => {
          return b.value - a.value
        })
        plateList = plateList.slice(0, 3)
        setPriceList(priceList)
        setDistrictList(districtList)
        setPlateList(plateList)
      }
    }
  }
  //  切换天数
  const changeTabs = index => {
    if (index == tabIndex) {
      return false
    }
    setTabIndex(index)
    listQuery.days = tabList[index]
    listQuery.pageInt = 1
    setListQuery(listQuery)
    fetchData()
  }
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  useEffect(() => {
    getDetail()
    fetchData()
  }, [])

  return (
    <div>
      <Card className="card">
        <div className="card-title">
          <div className="card-txt">楼盘偏好</div>
          <div className="housedetail-signtabs">
            {tabList.map((item, index) => {
              return (
                <div className={index == tabIndex ? 'housedetail-signtabs-item housedetail-signtabs-item-active' : 'housedetail-signtabs-item'} key={index} onClick={() => changeTabs(index)}>
                  {item} 天
                </div>
              )
            })}
          </div>
        </div>
        <div className={styles['address-list']} style={{ borderBottom: '1px solid #E8E8E8', padding: '32px 0 24px' }}>
          <div style={{ fontWeight: 'bold' }}>订阅楼盘：</div>
          {userInfo.followHouseList && userInfo.followHouseList.length > 0
            ? userInfo.followHouseList.map((item, index) => {
                return (
                  <div key={index}>
                    {item.houseName}
                    {index == list.length - 1 ? '' : '、'}
                  </div>
                )
              })
            : '暂无数据'}
        </div>
        <div className={styles['house-count']} style={{ marginTop: '32px' }}>
          <div>
            <span className="red">{tabList[tabIndex]}天</span>，该用户共访问楼盘<span className="green">{total}</span>个，以下是访问偏好分布（仅供参考）：
          </div>
        </div>
        <div className="flex-between" style={{ marginTop: '24px' }}>
          <div className={styles['house-chart-item']}>
            <div className={styles['chart-title']}>单价偏好（参考价）</div>
            <div className={styles['chart-item']}>
              <div className={styles['chart-item-left']}>
                {priceList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-left-txt']} key={index}>
                      {item.name}
                    </div>
                  )
                })}
              </div>
              <div className={styles['chart-item-right']}>
                {priceList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-right-item']} key={index}>
                      <div className={styles['chart-item-bar']} style={{ width: item.rate }} />
                      <div className="gray">{item.rate}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          <div className={styles['house-chart-item']}>
            <div className={styles['chart-title']}>区域偏好</div>
            <div className={styles['chart-item']}>
              <div className={styles['chart-item-left']}>
                {districtList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-left-txt']} key={index}>
                      {item.name}
                    </div>
                  )
                })}
              </div>
              <div className={styles['chart-item-right']}>
                {districtList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-right-item']} key={index}>
                      <div className={styles['chart-item-bar']} style={{ width: item.rate }} />
                      <div className="gray">{item.rate}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          <div className={styles['house-chart-item']}>
            <div className={styles['chart-title']}>板块偏好</div>
            <div className={styles['chart-item']}>
              <div className={styles['chart-item-left']}>
                {plateList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-left-txt']} key={index}>
                      {item.name}
                    </div>
                  )
                })}
              </div>
              <div className={styles['chart-item-right']}>
                {plateList.map((item, index) => {
                  return (
                    <div className={styles['chart-item-right-item']} key={index}>
                      <div className={styles['chart-item-bar']} style={{ width: item.rate }} />
                      <div className="gray">{item.rate}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
        <div className={styles['table-title']}>
          <span className="red">{tabList[tabIndex]}天</span>，访问楼盘明细：
        </div>
        <Table dataSource={list} loading={listLoading} pagination={false} rowKey="key">
          <Column title="楼盘" dataIndex="houseName" />
          <Column title="区域" dataIndex="districtName" />
          <Column title="板块" dataIndex="plateName" />
          <Column title="参考价" dataIndex="price" />
          <Column title="7天有效访问" dataIndex="weekVisitorNum" className="red" />
          <Column title="30天" dataIndex="monthVisitorNum" />
          <Column title="90天" dataIndex="quarterVisitorNum" />
          <Column title="180天" dataIndex="halfYearVisitorNum" />
          <Column title="首次访问" dataIndex="firstVisitTime" />
          <Column title="最近访问" dataIndex="newVisitTime" />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
  )
}
